<template>
    <div class="main">
        <div v-for="(item, index) in newArr" :key="index">
            <!-- 顶部banner -->
            <div class="topImg">
                <img src="../../static/images/top_pic@2x.png" class="topPc" />
                <img src="../../static/images/top_pic.png" class="topPic" />
            </div>
            <!-- 主要内容 -->
            <div class="information">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
                    <!-- id -->
                    <el-form-item prop="id">
                        <div class="label">
                            {{ item[2] }}:<a href="#how">
                                <span><img src="../../static/images/icon.png" alt="" /> {{ item[3] }} </span></a
                            >
                        </div>
                        <el-input
                            v-model="ruleForm.id"
                            :placeholder="item[4]"
                            oninput="if(value.length>100)value=value.slice(0,100)"
                            :disabled="isMail"
                        ></el-input>
                    </el-form-item>
                    <!-- redemption -->
                    <el-form-item prop="redemption">
                        <div class="label">{{ item[5] }}:</div>
                        <el-input
                            v-model="ruleForm.redemption"
                            :placeholder="item[6]"
                            oninput="if(value.length>100)value=value.slice(0,100)"
                            :disabled="isMail"
                        ></el-input>
                    </el-form-item>
                    <!-- 验证码 -->
                    <div v-show="!isMail">
                        <el-form-item prop="verification">
                            <div class="label">{{ item[7] }}:</div>
                            <div class="verify">
                                <el-input v-model="ruleForm.verification" :placeholder="item[8]" id="verify" :disabled="isMail"> </el-input>
                                <div class="code">
                                    <img :src="verificationCode" alt="" @click="refresh" />
                                </div>
                            </div>
                        </el-form-item>
                        <el-form-item>
                            <div class="gText">
                                *{{ item[10] }}
                                <!-- <img src="../../static/images/balloon01.png" alt="" />/ -->
                            </div>
                        </el-form-item>
                    </div>

                    <!-- 点击按钮 -->
                    <el-form-item>
                        <div class="exchange">
                            <div @click="submitForm" style="display: inline-block">
                                <img v-show="!isDisable" :src="require('../../static/images/' + selectValue + '/redeem.png')" />
                                <img v-show="isDisable" :src="require('../../static/images/' + selectValue + '/exchange.png')" />
                            </div>
                        </div>
                    </el-form-item>
                </el-form>
                <!-- 下载信息 -->
                <div class="storeWrap">
                    <a href="https://apps.apple.com/app/capybara-go/id6596787726" target="_target">
                        <img src="../../static/images/store_a.png" alt="" />
                    </a>
                    <a href="https://play.google.com/store/apps/details?id=com.habby.capybara" target="_target">
                        <img src="../../static/images/store_g.png" alt="" />
                    </a>
                </div>
            </div>

            <!-- 展示信息 -->
            <div class="exhibit" id="how">
                <h3>{{ item[11] }}</h3>
                <img :src="require('../../static/images/' + selectValue + '/illustratepic_01.png')" />
                <h3>{{ item[12] }}</h3>
                <img :src="require('../../static/images/' + selectValue + '/illustratepic_02.png')" />

                <!-- <p>© 2022 HABBY PTE. LTD. All Rights Reserved.</p> -->
                <p></p>
                <el-select v-model="selectValue" placeholder="请选择">
                    <Icon slot="prefix" type="ios-globe-outline" />
                    <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                        style="font-family: 'CookieRunBold' !important"
                    ></el-option>
                </el-select>
            </div>

            <!-- 弹框 -->
            <div class="body" v-show="isModal">
                <div class="modal">
                    <div class="" style="flex: 1">
                        <!-- 输入信息确认 -->
                        <h4 v-if="!isMessage">{{ item[16] }}{{ ruleForm.id }}</h4>
                        <p v-if="!isMessage">{{ item[17] }}</p>
                        <!-- 返回错误消息 -->
                        <p v-else>{{ message }}</p>
                    </div>

                    <div class="btnWrap">
                        <span @click="handleNo" :class="{ span: isNo }" v-show="!isMessage"> {{ item[19] }} </span>
                        <span @click="handleYes" :class="{ span: isYes }" v-show="!isMessage"> {{ item[18] }} </span>
                        <span @click="handleOk" :class="{ span: isOk }" class="spanOk" v-show="isMessage"> OK </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { lang } from '@/tool/lang'
import { myHTTP } from '@/utils/net'
import queryString from 'query-string'
// import GameFeaturesVue from '../../../../src/components/GameFeatures.vue'

const parsed = queryString.parse(location.search || '') || {}
export default {
    props: ['language'],
    data() {
        var validateId = (rule, value, callback) => {
            if (value === '') {
                callback(new Error(this.newArr[0][25]))
            } else {
                callback()
            }
        }
        var validateRedemption = (rule, value, callback) => {
            if (value === '') {
                callback(new Error(this.newArr[0][26]))
            } else {
                callback()
            }
        }
        var validateVerification = (rule, value, callback) => {
            if (value === '') {
                callback(new Error(this.newArr[0][27]))
            } else {
                callback()
            }
        }
        var validateMail = (rule, value, callback) => {
            // const mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/
            // if (value === '' || !mailReg.test(value)) {
            if (value === '') {
                callback(new Error(this.newArr[0][28]))
            } else {
                callback()
            }
        }
        return {
            enMail: 'Check the rewards code in your email.',
            enBind: 'Your email address to redeem rewards is',
            bindMail: '',
            isMail: false,
            isMessage: false,
            isModal: false,
            isNo: false,
            isYes: false,
            isClick: true,
            isOk: false,
            isNull: false,
            ruleForm: {
                id: '',
                redemption: '',
                verification: ''
            },
            ruleForm1: {
                mail: ''
            },
            rules: {
                id: [{ required: true, trigger: ['blur', 'change'], validator: validateId }],
                redemption: [{ required: true, trigger: ['blur', 'change'], validator: validateRedemption }],
                verification: [{ required: true, trigger: ['blur', 'change'], validator: validateVerification }]
            },
            rules1: {
                mail: [{ required: true, trigger: ['blur', 'change'], validator: validateMail }]
            },
            options: [
                {
                    value: 'en',
                    label: 'English'
                },
                {
                    value: 'ja',
                    label: '日本語'
                },
                {
                    value: 'ko',
                    label: '한국어'
                },
                {
                    value: 'zh-TW',
                    label: '繁體中文'
                }
            ],
            selectValue: 'en',
            newArr: [{}],
            verificationCode: '',
            captchaId: '',
            message: '',
            isOk: false,
            isDisable: false
        }
    },
    watch: {
        selectValue: function (val, old) {
            if (val) {
                this.getLang(this.selectValue)

                this.$refs['ruleForm'][0].validate(valid => {})
            }
        }
    },
    created() {
        this.getLang(this.language)
        this.selectValue = this.language
        this.getId()
        this.init()
        if (parsed.code) {
            this.ruleForm.redemption = parsed.code
        } else {
            return
        }
    },
    methods: {
        init() {
            document.documentElement.addEventListener(
                'touchstart',
                function (event) {
                    if (event.touches.length > 1) {
                        event.preventDefault()
                    }
                },
                false
            )
            var lastTouchEnd = 0
            document.documentElement.addEventListener(
                'touchend',
                function (event) {
                    var now = Date.now()
                    if (now - lastTouchEnd <= 300) {
                        event.preventDefault()
                    }
                    lastTouchEnd = now
                },
                false
            )
            document.addEventListener('gesturestart', function (event) {
                event.preventDefault()
            })
        },
        getLang(language) {
            for (var i in lang) {
                this.newArr[0][i] = lang[i][language]
            }
            console.log(this.newArr[0][47], '～～～～～～～～～1-——————————————')
        },
        submitForm() {
            if (this.isDisable === true) {
                return
            }
            if (this.isMail) {
                this.isDisable = true
                // this.$refs['ruleForm1'][0].validate(valid => {
                //     if (valid) {
                //         this.isModal = true
                //     } else {
                //         return false
                //     }
                // })
            } else {
                this.$refs['ruleForm'][0].validate(valid => {
                    if (valid) {
                        this.isModal = true
                    } else {
                        console.log('error submit!!')
                        return false
                    }
                })
            }
        },
        resetForm(formName) {
            this.$refs[formName][0].resetFields()
        },
        handleYes() {
            if (this.isMessage) {
                this.isMessage = false
            } else {
                this.claim()
                this.getId()
            }
            this.isYes = true
            this.isModal = false
            this.isYes = false
        },
        handleOk() {
            this.isOk = true
            this.isModal = false
            this.isOk = false
            this.isMessage = false
        },
        handleNo() {
            this.isMessage = false
            this.isNo = true
            this.isModal = false
            this.isNo = false
        },
        getId() {
            myHTTP.post('/api/v1/captcha/generate').then(res => {
                this.captchaId = res.data.data.captchaId
                myHTTP.get(`/api/v1/captcha/image/${res.data.data.captchaId}`).then(res => {
                    this.verificationCode = res.config.url
                    this.isClick = true
                })
            })
        },
        refresh() {
            if (this.isClick) {
                this.isClick = false
                this.getId()
            } else {
                return
            }
        },
        claim() {
            this.isDisable = true
            let aclaim = ''
            if (this.ruleForm.id.indexOf('-') !== -1) {
                // aclaim = this.ruleForm.id.replace(/\s/g, '').split('-')[1]
                aclaim = this.ruleForm.id.split('-')[1].replace(/^\s+|\s+$/gm, '')
            } else {
                // aclaim = this.ruleForm.id.replace(/\s/g, '')
                aclaim = this.ruleForm.id.replace(/^\s+|\s+$/gm, '')
            }
            myHTTP
                .post('/api/v1/giftcode/claim', {
                    userId: aclaim,
                    // giftCode: this.ruleForm.redemption.replace(/\s/g, ''),
                    // captcha: this.ruleForm.verification.replace(/\s/g, ''),
                    // captchaId: this.captchaId.replace(/\s/g, '')

                    giftCode: this.ruleForm.redemption.replace(/^\s+|\s+$/gm, ''),
                    captcha: this.ruleForm.verification.replace(/^\s+|\s+$/gm, ''),
                    captchaId: this.captchaId.replace(/^\s+|\s+$/gm, '')
                })
                .then(res => {
                    this.isDisable = false

                    this.isMessage = true
                    this.isModal = true
                    let code = res.data.code
                    if (code === 0) {
                        // this.isMail = true
                        // this.bindShow = true
                        this.message = this.newArr[0][20]
                    } else if (code === 20001) {
                        this.message = this.newArr[0][37]
                    } else if (code === 20002) {
                        this.message = this.newArr[0][38]
                    } else if (code === 20003) {
                        this.message = this.newArr[0][21]
                    } else if (code === 20401) {
                        this.message = this.newArr[0][22]
                    } else if (code === 20402) {
                        this.message = this.newArr[0][23]
                    } else if (code === 20403) {
                        this.message = this.newArr[0][24]
                    } else if (code === 20404) {
                        this.message = this.newArr[0][45]
                    } else if (code === 20409) {
                        this.message = this.newArr[0][46]
                    } else if (code === 20407) {
                        this.message = this.newArr[0][47]
                    } else if (code === 20410) {
                        this.message = this.newArr[0][48]
                    } else if (code === 30001) {
                        this.message = this.newArr[0][39]
                    } else {
                        this.message = this.newArr[0][39] + '(' + code + ')'
                    }
                })
        }
    }
}
</script>

<style scoped lang="less">
.main {
    width: 100%;
    overflow: hidden;
    position: relative;
    // font-family: 'CookieRunBlack';
    font-family: 'CookieRunBold';
    // modal
    .body {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.42);
        .modal {
            line-height: 2.25rem;
            width: 35.625rem;
            height: 23.75rem;
            background: #ffffff;
            border-radius: 1.125rem;
            box-shadow: 0 0.5rem 3.375rem 0 #6e8eb8;
            padding: 4.9375rem 2.25rem 1.625rem;
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            margin: auto;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            h4 {
                color: #ee7f33;
                font-size: 2.25rem;
                margin-bottom: 1.375rem;
            }
            p {
                font-size: 1.2rem;
                color: #151515;
            }
            .btnWrap {
                display: flex;
                justify-content: space-between;
                .spanOk {
                    margin: 0 auto;
                }
                span {
                    display: inline-block;
                    width: 45%;
                    font-size: 1.875rem;
                    line-height: 1.875rem;

                    border-radius: 0.701875rem;
                    border: 0.175625rem solid #ee7f33;
                    padding: 1.75rem 0;
                    color: #ee7f33;
                    cursor: pointer;
                }
                span:hover {
                    color: white;
                    background: #ee7f33;
                }
                .span {
                    color: white;
                    background: #ee7f33;
                }
            }
        }
    }
    // 顶部banner
    .topImg {
        text-align: center;
        overflow: hidden;
        position: relative;
        .topPc {
            display: none;
        }
        .topPic {
            display: inline-block;
            width: 100%;
        }
        @media screen and (min-width: 1024px) {
            .topPc {
                display: inline-block;
                width: 100%;
                height: auto;
            }
            .topPic {
                display: none;
            }
        }
    }
    // 输入信息
    .information {
        display: inline-block;
        font-size: 1.2rem;
        line-height: 1.5rem;

        width: 37.5rem;
        max-width: 600px;
        /deep/.el-form-item {
            margin-top: 2.1875rem;
            // 输入框头部信息
            .label {
                font-size: 1.2rem;
                line-height: 1.5rem;

                text-align: left;
                padding: 1.25rem 0 1rem 1.375rem;
                color: #000000;
                span {
                    float: right;
                    color: #aaadb7;
                    font-size: 1.17rem;
                    img {
                        width: 0.975rem;
                    }
                }
            }
            // 验证码输入框
            .verify {
                display: flex;
                justify-content: space-between;
                align-items: center;
                .el-input {
                    display: inline-block;
                    width: 26.875rem;
                    max-width: 430px;
                }
                #verify {
                    width: 26.875rem;
                    max-width: 430px;
                }
                .code {
                    flex: 1;
                    height: 4rem;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-left: 1.25rem;
                    img {
                        cursor: pointer;
                        width: 100%;
                        height: 100%;
                    }
                }
            }
            // 绿色提示文案
            .gText {
                text-align: left;
                color: #ee7f33;
                font-size: 1.2rem;
                line-height: 2.25rem;
                margin-left: 1.375rem;
                position: relative;
                img {
                    height: 17.75rem;
                    width: auto;
                    position: absolute;
                    top: 0;
                    right: -5.875rem;
                }
            }
            // mail上方带图片的文案
            .mailText {
                img {
                    height: 2.5rem;
                    vertical-align: center;
                }
                color: #1a1a1a;
                text-align: left;
                margin-left: 1.375rem;
                line-height: 2.5rem;
                font-size: 1.2rem;
                margin-bottom: 1.25rem;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box; //作为弹性伸缩盒子模型显示。
                -webkit-box-orient: vertical; //设置伸缩盒子的子元素排列方式--从上到下垂直排列
                -webkit-line-clamp: 2; //显示的行
            }
            .exchange {
                img {
                    height: auto;
                    width: 16.0625rem;
                    max-width: 257px;
                    cursor: pointer;
                }
            }
        }
        // 输入框
        /deep/input {
            text-align: center;
            height: 4.75rem;
            width: 37.5rem;
            max-width: 600px;
            max-height: 76px;
            border-radius: 2.38875rem;
            color: #aaadb7;
            font-size: 1.2rem;
            line-height: 1.5rem;

            box-shadow: 0 0.1875rem 0.1875rem 0 rgba(0, 0, 0, 0.42);
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        // 错误信息
        /deep/.el-form-item__error {
            text-indent: 2.8125rem;
            color: #ff5565;
            font-size: 1.25rem;
        }
    }

    // 下载信息
    .storeWrap {
        margin: 2.5rem 0;
        display: flex;
        justify-content: space-around;
        a {
            width: 40%;
        }
        img {
            width: 100%;
        }
    }
    // 展示信息
    .exhibit {
        margin: 0 auto;
        padding-bottom: 2.375rem;
        position: relative;
        width: 100%;
        max-width: 744px;
        h3 {
            color: #151515;
            font-size: 1.2rem;
            line-height: 1.5rem;

            margin-bottom: 1.1875rem;
        }
        img {
            display: inline-block;
            width: 27.375rem;
            max-width: 438px;
            border-radius: 0.5rem;
            margin-bottom: 3.125rem;
        }
        p {
            font-size: 1.125rem;
            color: #aaadb7;
            line-height: 1.125rem;

            margin: 1.875rem 0 1.25rem;
        }
        /deep/input {
            border-radius: 2.28125rem;
            color: #aaadb7;
            font-size: 1.17rem;
            line-height: 1.4625rem;
            text-align: center;

            height: 4.375rem;
            width: 13.75rem;
            max-height: 54px;
            max-width: 220px;
            box-sizing: content-box;
            padding: 0;
        }
        /deep/.el-input__prefix {
            display: flex;
            align-items: center;
            width: 1.875rem;
            font-size: 1.875rem;

            margin: 0 0.6rem;
            color: #aaadb7;
        }
        /deep/.el-input__icon {
            display: flex;
            align-items: center;
            width: 1.25rem;
            font-size: 1.25rem;

            margin: 0 0.6rem;
        }
        /deep/.el-select-dropdown__item {
            padding: 0;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/Main.vue